/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_RECRUITSGROUPDATA, RECRUITSGROUPDATA_RECEIVED } = constants.RecruitsGroupConstant;

export default {
    REQUEST_RECRUITSGROUPDATA,
    RECRUITSGROUPDATA_RECEIVED,

  requestRecruitgroup: payload => ({
    type: REQUEST_RECRUITSGROUPDATA,
    payload
  }),
  recruitgroupReceived: () => ({
    type: RECRUITSGROUPDATA_RECEIVED
  }),
};
